import DataSourceSection from '../../components/DataSourceSection'
import IndicatorSection from '../../components/IndicatorSection'
import type { Municipality, MakrolageData, CountySnapshot } from '../../types/api'

interface KreisTabProps {
  municipality: Municipality
  makrolageData: MakrolageData | undefined
  currentCountySnapshot: CountySnapshot | undefined
  effectiveEdition: number | null
}

export default function KreisTab({
  municipality,
  makrolageData,
  currentCountySnapshot,
  effectiveEdition,
}: KreisTabProps) {
  if (!makrolageData) {
    return (
      <div className="status-error text-center">
        <p>Keine Kreis-Daten verfügbar</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Gemeindeverzeichnis - County base data (GV100AD + GV100NAD) */}
      <DataSourceSection
        title={`Gemeindeverzeichnis: ${municipality.county?.name || 'N/A'}`}
        dataSource={currentCountySnapshot?.data_source ?? undefined}
        data={{
          // GV100AD - Allgemeine Daten
          kreisschlüssel: makrolageData.county_key,
          ags: makrolageData.county_ags,
          name: currentCountySnapshot ? currentCountySnapshot.name : makrolageData.county_name,
          bezeichnung: makrolageData.county_designation,
          textkennzeichen: makrolageData.county_textkennzeichen_label || makrolageData.county_textkennzeichen,
          kreissitz: makrolageData.county_administrative_seat,
          anzahl_gemeinden: currentCountySnapshot?.num_municipalities ?? makrolageData.num_municipalities,
          einwohner: currentCountySnapshot ? currentCountySnapshot.population : makrolageData.population,
          fläche_km2: currentCountySnapshot ? currentCountySnapshot.area_km2 : makrolageData.area_km2,
          bevölkerungsdichte: currentCountySnapshot ? currentCountySnapshot.population_density : makrolageData.population_density,
          // GV100NAD - Klassifikationen
          siedlungsstruktur: currentCountySnapshot ? currentCountySnapshot.settlement_structure : makrolageData.settlement_structure,
          raumtyp: currentCountySnapshot ? currentCountySnapshot.spatial_type : makrolageData.spatial_type,
          braunkohlerrevier: makrolageData.coal_mining_area,
          raumordnungsregion: makrolageData.spatial_planning_region_name,
          arbeitsmarktregion: makrolageData.labor_market_region_name,
        }}
      />

      {/* Indicators (Regionalstatistik, INKAR, etc.) */}
      {makrolageData.county_ags && (
        <IndicatorSection
          entityType="county"
          ags={makrolageData.county_ags}
          maxYear={effectiveEdition ? effectiveEdition - 1 : undefined}
        />
      )}
    </div>
  )
}
